import type { SxProps, Theme } from "@mui/material/styles";

export const pageStack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: { xs: theme.spacing(2), md: theme.spacing(2.75) },
});

export const desktopHeader: SxProps<Theme> = {
  display: { xs: "none", md: "block" },
};

export const layoutGrid: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "260px 1fr" },
  gap: { xs: 0, md: 3 },
  alignItems: "start",
};

export const mobileTabsRow: SxProps<Theme> = {
  display: { xs: "flex", md: "none" },
  alignItems: "center",
  gap: 1,
  px: 1.75,
  py: 1.5,
  overflowX: "auto",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": { display: "none" },
  bgcolor: "background.paper",
  borderBottom: 1,
  borderColor: "divider",
  mx: { xs: -2, sm: 0 },
};

export const contentCard: SxProps<Theme> = {
  bgcolor: "background.paper",
  border: { xs: "none", md: 1 },
  borderColor: "divider",
  borderRadius: { xs: 0, md: 3 },
  boxShadow: { xs: "none", md: 3 },
  p: { xs: 2.25, md: 3.75 },
  display: "flex",
  flexDirection: "column",
  gap: 3,
  minHeight: { md: 460 },
};

export const tabHeader: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.5,
};

export const tabTitle: SxProps<Theme> = {
  fontSize: { xs: "0.90625rem", md: "1rem" },
  fontWeight: 700,
};

export const tabSubtitle: SxProps<Theme> = {
  fontSize: { xs: "0.71875rem", md: "0.78125rem" },
  color: "text.secondary",
  lineHeight: 1.7,
};

export const mobileContent: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 2.5,
  px: { xs: 0, sm: 0 },
};
